package com.sweetlime.bingeamigo.model

data class ActivityUserContext(
    val libraryMovie: LibraryMovie? = null,
    val libraryShow: LibraryTvShow? = null
)